module.exports = __webpack_public_path__ + "img/info.b60c1bc5.png";